export default [
  { label: 'Event', key: 'event' },
  { label: 'Status', key: 'status' },
  { label: 'StartDate', key: 'startDate' },
  { label: 'EndDate', key: 'endDate' },
  { label: 'Director', key: 'director' },
  { label: 'GrandTotal', key: 'grandTotal' },
  { label: 'AmountPaid', key: 'amountPaid' },
  { label: 'Due', key: 'due' },
]


// WEBPACK FOOTER //
// ./src/containers/reports/constants/financeHeaders.js